// Which pages belong to Medical History, for the sidebar and the tab bar.
//
// One list, read by both — Header.js (the sidebar) and MedicalHistoryNav.js
// (the tabs across the top of Medical History) — so the two cannot disagree
// about where the patient is.
//
// THE TREATMENT LIST HAS TWO HOMES. It is a tab inside Medical History
// (/TreatMentWithUs, under the Medical History heading and tabs) and a page of
// its own from the sidebar (/Treatments, with nothing of Medical History
// around it). Each address says for itself which sidebar item it belongs to.
//
// The Details and Images pages opened from either list are the same pages at
// the same address, so for those the list records which home it was opened
// from (TreatmentWithUs.js does it as it opens), and they keep that item lit.
// With nothing recorded — an address typed in or bookmarked — they count as
// Medical History, the older of the two.

// The Patient Medical History tab. The Hull clinic's questionnaire lives at
// its own addresses — /MedicalSocialHistory (female), /MedicalSocialHistory2
// (male), /Medical_History — and these used to be missing, so for a Hull
// patient neither the tab nor the sidebar showed where they were.
export const PATIENT_MEDICAL_HISTORY_PAGES = [
  "MedicalHistory",
  "MedicalSocialHistory",
  "MedicalSocialHistory2",
  "Medical_History",
];

// Everything under Medical History's tabs.
export const MEDICAL_HISTORY_PAGES = [
  ...PATIENT_MEDICAL_HISTORY_PAGES,
  "TreatMentWithUs",
  "PreviousFertilityTreatment",
  "PreviousPregnancy",
  "Allergies",
  "PreviousProcedure",
  "Prescription",
  "PrescriptionDetail",
  "DrugReminder",
];

// The sidebar's own treatment page.
export const TREATMENTS_PAGE = "Treatments";

// The Details and Images pages opened from a treatment list — either one.
export const TREATMENT_DETAIL_PAGES = ["TreatmentOutcome", "DicomViewer"];

const KEY = "treatmentsOpenedFrom";

// Called by the treatment list as it opens: "sidebar" (standalone, at
// /Treatments) or "medicalHistory" (the tab).
export function setTreatmentsOpenedFrom(where) {
  try {
    sessionStorage.setItem(KEY, where);
  } catch {
    // Storage blocked: the highlight falls back to Medical History.
  }
}

function openedFromSidebar() {
  try {
    return sessionStorage.getItem(KEY) === "sidebar";
  } catch {
    return false;
  }
}

// Is the sidebar's "Medical History" the current place?
export function isMedicalHistoryActive(page) {
  return MEDICAL_HISTORY_PAGES.includes(page) || (TREATMENT_DETAIL_PAGES.includes(page) && !openedFromSidebar());
}

// Is the sidebar's "Treatment with Us" the current place?
export function isTreatmentsActive(page) {
  return page === TREATMENTS_PAGE || (TREATMENT_DETAIL_PAGES.includes(page) && openedFromSidebar());
}
